export default {
  title: {
    en: 'Order #{orderNo}',
  },
  date: {
    en: 'Billed: <strong>{billingDate}</strong>',
  },
  total: {
    en: 'Total: <strong>{total}</strong>',
  },
}
